<template>
  <AppModal id="pre-import-timesheets-rapport" :close-on-backdrop="closeOnBackdrop">

    <template #title>
      <h3 class="text-center mb-5">{{$t($getConst.pages.vendor_timesheets.vendor_timesheets_rapport_title) | capitalize}}</h3>
    </template>

    <template #content>
      <div class="mx-auto text-center">
        <input
          type="file"
          name="file"
          id="file"
          class="input-file"
          :disabled="isLoading"
          @change="generatePreImportTimesheetsRapport"
        />
        <label for="file">
          <i :class="[$getConst.icons.upload, 'mr-2']"/>
          <span v-if="!file">{{$t($getConst.pages.form.choose_file)}}</span>
          <span v-else>{{file.name}}</span>
        </label>
      </div>

      <b-list-group id="success-rapport" v-if="isRapportGenerated" class="my-3">
        <b-list-group-item class="bg-light d-flex justify-content-between align-items-center font-weight-bold">
          {{$t($getConst.pages.vendor_timesheets.vendor_timesheets_rapport_total_timesheets)}}
          <span>{{rapport.timesheetsCount}}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          {{$t($getConst.pages.vendor_timesheets.vendor_timesheets_rapport_timesheets_to_create)}}
          <span>{{rapport.timesheetsToCreate}}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center">
          {{$t($getConst.pages.vendor_timesheets.vendor_timesheets_rapport_timesheets_to_update)}}
          <span>{{rapport.timesheetsToUpdate}}</span>
        </b-list-group-item>
      </b-list-group>

      <b-list-group id="missing-columns" v-if="missingColumns.length > 0" class="my-3">
         <b-list-group-item class="bg-light d-flex justify-content-between align-items-center text-danger">
          <h5>
            <b>{{$t($getConst.pages.vendor_timesheets.vendor_timesheets_rapport_missing_columns)}}</b>
          </h5>
        </b-list-group-item>
        <b-list-group-item v-for="column in missingColumns" class="justify-content-between align-items-center font-weight-bold">
           {{ column }}
        </b-list-group-item>
      </b-list-group>

      <b-list-group id="pending-response" v-if="reportIsPending" class="my-3">
         <b-list-group-item class="d-flex justify-content-between align-items-center text-success">
          <h5>
            <b>{{$t($getConst.pages.vendor_timesheets.vendor_timesheets_report_is_pending)}}</b>
          </h5>
        </b-list-group-item>
      </b-list-group>

      <b-list-group id="failed-rapport" v-else-if="failedResponse" class="overflow-auto">
        <b-list-group-item class="d-flex bg-light justify-content-between align-items-center text-danger">
          <h5>
            <b>{{$t($getConst.pages.vendor_timesheets.vendor_timesheets_rapport_total_invalid_timesheets)}}</b>
          </h5>
          <span class="badge badge-danger badge-pill w-auto">{{Object.keys(failedResponse).length}}</span>
        </b-list-group-item>
        <template v-for="(errors, row) in failedResponse">
          <a type="button" v-b-toggle="'row-'+row" class="list-group-item d-flex justify-content-between align-items-center py-2 px-4">
            {{$t($getConst.pages.vendor_timesheets.vendor_timesheets_rapport_row)}} {{row}}
            <span><i :class="$getConst.icons.chevron_down"/></span>
          </a>
          <b-collapse :id="'row-'+row" accordion="my-accordion" class="list-group-item">
            <ul class="mb-0">
              <li v-for="error in errors">
                {{Object.keys(error)[0]}}:
                <span class="float-right">{{$t($getConst.pages.vendor_timesheets["vendor_timesheets_rapport_"+Object.values(error)[0]])}}</span>
              </li>
            </ul>
          </b-collapse>

        </template>
      </b-list-group>

      <b-progress v-if="isLoading" class="mx-auto w-75" show-progress animated variant="secondary" height="3rem">
        <b-progress-bar class="font-weight-bold font-size-md" :value="uploadPercentage" :label="`${uploadPercentage}%`"/>
      </b-progress>
    </template>

    <template v-if="isRapportGenerated || reportIsPending" #button>
      <AppConfirmButtons
        :submit-text="submitButtonText"
        :is-loading="isLoading"
        @onSubmit="submitTimesheetsReport"
        @onCancel="closeModal"
      />
    </template>

  </AppModal>
</template>

<script>
  import AppModal from "../../../components/common/modals/AppModal";
  import {getPreImportTimesheetsRapport, uploadTimesheetsExcel} from "../../../api/vendorTimesheets.api";
  import AppConfirmButtons from "../../../components/common/utils/AppConfirmButtons";
  export default {
    name: "PreImportTimesheetsRapportModal",
    components: {AppConfirmButtons, AppModal},
    props: {
      scopeId: null
    },
    data() {
      return {
        file: null,
        uploadPercentage: 0,
        isLoading: false,
        isRapportGenerated: false,
        missingColumns: [],
        failedResponse: null,
        reportIsPending: false,
        rapport: {
          timesheetsToCreate: 0,
          timesheetsToUpdate: 0,
          timesheetsCount: 0
        },
        closeOnBackdrop: true
      }
    },
    computed: {
      submitButtonText() {
        if (this.reportIsPending) {
          return this.$t(this.$getConst.pages.vendor_timesheets.open_pending_jobs);
        } else {
          return this.$t(this.$getConst.pages.vendor_timesheets.vendor_timesheets_rapport_import_timesheets);
        }
      }
    },
    methods: {
      submitTimesheetsReport() {
        if (this.reportIsPending) {
          this.$router.push({name: this.$getConst.routesNames.administration.jobsLogs});
        } else {
          this.isLoading = true;
          this.uploadPercentage = 0;
          uploadTimesheetsExcel(
            this.$store.getters['auth/scopeDefault'].id,
            this.file,
            (event) => {
              this.uploadPercentage = Math.round(100 * event.loaded / event.total);
            }
          ).then(() => {
            this.uploadPercentage = 0;
            this.isLoading = false;
            this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
            this.closeModal();
            this.$emit("importedTimesheets");
          }).catch((error) => {
            this.uploadPercentage = 0;
            this.isLoading = false;
            this.handleApiError(error);
          });
        }
      },
      generatePreImportTimesheetsRapport(event) {
        this.file = event.target.files[0];
        this.resetRapport();

        if (this.file) {
          this.closeOnBackdrop = false;
          this.isLoading = true;
          getPreImportTimesheetsRapport(
            this.scopeId,
            this.file,
            (event) => {
              this.uploadPercentage = Math.round(100 * event.loaded / event.total);
            }
          ).then(
            (response) => {
              if (response.data.status === "missing_columns") {
                this.missingColumns = response.data.data;
                this.closeOnBackdrop = true;
              }
              else if (response.data.status === "pending") {
                this.reportIsPending = true;
              }
              else if (response.data.status === "failed") {
                this.failedResponse = response.data.data;
                this.closeOnBackdrop = true;
              } else {
                this.rapport = response.data.data;
                this.isRapportGenerated = true;
              }
              this.isLoading = false;
            },
            (error) => {
              this.handleApiError(error);
              this.resetRapport();
              this.isLoading = false;
            }
          )
        }
      },
      resetRapport() {
        this.uploadPercentage = 0;
        this.isRapportGenerated = false;
        this.closeOnBackdrop = true;
        this.failedResponse = null;
        this.reportIsPending = false;
        this.missingColumns = [];
        this.rapport = {
          timesheetsToUpdate: 0,
          timesheetsToCreate: 0,
          timesheetsCount: 0
        }
      },
      closeModal() {
        this.$bvModal.hide("pre-import-timesheets-rapport");
      }
    },
    mounted() {
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        if (modalId === "pre-import-timesheets-rapport") {
          this.resetRapport();
          this.file = null;
        }
      })
    }
  }
</script>

<style scoped>
  #success-rapport.list-group {
    border-radius: 0 !important;
  }
  #success-rapport.list-group-item {
    border: none !important;
  }
  #failed-rapport {
    max-height: 50vh;
  }
</style>
